import {Switch as SwitchPrimitive} from "@base-ui/react/switch"
import {clsx} from "clsx"
import styles from "./Switch.module.css"


function Switch({
					 className,
					 ...props
				 }: SwitchPrimitive.Root.Props) {
	return (
		<SwitchPrimitive.Root
			data-slot="switch"
			className={clsx(styles.root, className)}
			{...props}
		>
			<SwitchPrimitive.Thumb
				data-slot="switch-thumb"
				className={styles.thumb}
			/>
		</SwitchPrimitive.Root>
	)
}

export {Switch}
